import { DisplayedProduct, Product, ProductStructureOverride } from 'app/models/menu.model';

export class DefaultSizeIdOverrideService {

  public static overrideDefaultSizeId(
    originalProduct: Product,
    displayedProduct: DisplayedProduct,
    overrideProductStructure: ProductStructureOverride)
  {
    if (!originalProduct.productStructure){
      return;
    }

    const originalSizes = originalProduct.productStructure.sizes;

    if (!originalSizes || originalSizes.length === 0){
      return;
    }

    if (overrideProductStructure.defaultSizeId === undefined){
      return;
    }

    if (overrideProductStructure.defaultSizeId == defaultSizeDisabled){
      displayedProduct.productStructure.defaultSizeId = defaultSizeDisabled;
      return;
    }

    if (overrideProductStructure.defaultSizeId !== null
      && !originalSizes.some(s => s.sizeId === overrideProductStructure.defaultSizeId))
    {
      // если больше размера из оверрайдов нет среди оригинальных размеров, то логично в лк его не переопределять.
      return;
    }

    displayedProduct.productStructure.defaultSizeId = overrideProductStructure.defaultSizeId;
  }
}

// Переменная говорит о том, что размеры по умолчанию должны быть отключены в любом случае.
// Сделать оверрайд { defaultSizeId: null} не получается, т.к. сервер одинаково десериализует этот оверайд как и пустой {}
export const defaultSizeDisabled = 'defaultSizeDisabled';
